const FOCUSABLE_ELEMENTS_SELECTOR =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

/**
 * Gets keyboard-focusable elements within a specified element
 * @param {HTMLElement} [element=document] element
 * @returns {Array}
 */
export function getFocusableElements(element = document.body): Element[] {
    return Array.from(element.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR)).filter(
        el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden')
    );
}

export function getFirstAndLastFocusableElements(element = document.body): Element[] {
    const focusableElements = getFocusableElements(element);
    return [focusableElements[0], focusableElements[focusableElements.length - 1]];
}
